import { LoadingOutlined } from '@ant-design/icons'
import { Spin } from 'antd'
import Lottie from 'lottie-react'

import { useGlobalLoading } from '@/store/globalLoading'
import loadingAnimation from '@/assets/animation/loading.json'

import styles from './index.module.less'

export const GlobalLoading = () => {
  const { globalLoading } = useGlobalLoading()

  return (
    <Spin
      spinning={globalLoading}
      fullscreen
      indicator={
        <Lottie
          animationData={loadingAnimation}
          loop={true}
          className={styles.box}
        />
      }
    />
  )
}
